import { openDB, type DBSchema, type IDBPDatabase } from 'idb'
import type { DesignDocument } from '@pfe/design-renderer'

/**
 * Lokale Entwürfe des Design-Editors (eigene DB, `imageDB` bleibt unangetastet).
 * Jeder Commit im Store schreibt einen Draft; beim Laden wird ein neuerer lokaler Stand
 * gegenüber dem Server angeboten.
 */
export type DesignDraft = {
  id: string
  projectCode: string
  document: DesignDocument
  serverVersion: number
  savedAt: number
}

interface DesignDbSchema extends DBSchema {
  drafts: { key: string; value: DesignDraft; indexes: { 'by-project': string } }
}

let dbPromise: Promise<IDBPDatabase<DesignDbSchema>> | null = null

function db(): Promise<IDBPDatabase<DesignDbSchema>> {
  if (!dbPromise) {
    dbPromise = openDB<DesignDbSchema>('designDB', 1, {
      upgrade(database) {
        const store = database.createObjectStore('drafts', { keyPath: 'id' })
        store.createIndex('by-project', 'projectCode')
      },
    })
  }
  return dbPromise
}

export const designDrafts = {
  async get(id: string): Promise<DesignDraft | null> {
    try { return (await (await db()).get('drafts', id)) ?? null } catch { return null }
  },
  async put(draft: DesignDraft): Promise<void> {
    try { await (await db()).put('drafts', draft) } catch { /* Speicher voll / privat */ }
  },
  async delete(id: string): Promise<void> {
    try { await (await db()).delete('drafts', id) } catch {}
  },
}
